import React from 'react';
import RegisterContainer from "../containers/RegisterContainer";

const RegisterView = () => {
  return (
    <div>
      <RegisterContainer/>
    </div>
  );
};

export default RegisterView;
